
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/nagoyatv",
      function () {
        return require("private-next-pages/cases/nagoyatv/index.tsx");
      }
    ]);
  